<script>
import axios from "axios";

export default {
  name: "LifeInsuranceApplications",
  data() {
    return {
      formData: {
        name: "",
        email: "",
        phone: "",
        amount: "",
      },
      submitted: false,
      currentLanguage: 'en',
      agentInfo: {
        firstName: '',
        lastName: '',
        profileIMG: ''
      }
    };
  },
  methods: {
    setLanguage(lang) {
      this.$i18n.locale = lang;
      this.currentLanguage = lang;
      localStorage.setItem('landing_lang', lang);
    },
    async fetchAgentInfo() {
      const urlParams = new URLSearchParams(window.location.search);
      const rawAgent = urlParams.get('agent');
      if (!rawAgent) return;

      try {
        const response = await axios.get(`/api/public-agent-info?agent=${rawAgent}`);
        if (response.data) {
          this.agentInfo = response.data;
        }
      } catch (error) {
        console.error("Agent not found:", error);
      }
    },
    async submitForm() {
      // Split name into first and last
      const names = this.formData.name.trim().split(/\s+/);
      const firstName = names[0] || '';
      const lastName = names.slice(1).join(' ') || 'N/A';

      // Get agent ID from URL (obfuscated) or use default (2978 for Daniela Etchegoyen)
      const urlParams = new URLSearchParams(window.location.search);
      const rawAgent = urlParams.get('agent');
      
      let agentId = 2978; // Default
      if (rawAgent) {
        // Obfuscation logic: decoded = (val ^ 271828) / 314159
        try {
          const val = parseInt(rawAgent, 36);
          const decoded = (val ^ 271828) / 314159;
          if (Number.isInteger(decoded)) {
            agentId = decoded;
          } else if (!isNaN(parseInt(rawAgent)) && parseInt(rawAgent) > 100000) {
             // If legacy or direct number, verify (optional)
             // but here we prefer to stick to the secure logic
          }
        } catch (e) {
          console.error("Invalid agent code");
        }
      }

      const payload = {
        token: "public-landing-page",
        userID: "public",
        userEmail: "landing-page@dmbgroup.online", // Added to avoid KeyError in backend
        isProspect: 1,
        clientsInfo: {
          0: {
            formValues: {
              firstName: firstName,
              lastName: lastName,
              email: this.formData.email,
              phoneNumber: this.formData.phone,
              language: this.currentLanguage === 'en' ? 1 : 2,
              status: 1, // ID
              leadType: 'CRM Leads Form', // Source
              agentId: agentId,
              gender: 'M', // Default
              note: `Requested Coverage: ${this.formData.amount}`,
              birthday: 'N/A',
              address: 'N/A',
              city: 'N/A',
              state: 'N/A',
              postalCode: 'N/A',
              country: 'United States',
              department: 24, // Telesales
              interview: 'N/A'
            },
            addedChilds: [],
            note: { note: `Life Insurance Quote - Amount: ${this.formData.amount}. Submitted via Landing Page.` }
          }
        }
      };

      try {
        const response = await axios.post('/api/client/createProspectForm', payload);
        if (response.data === true) {
          this.submitted = true;
          // Reset form after success message
          setTimeout(() => {
            this.submitted = false;
            this.formData = {
              name: "",
              email: "",
              phone: "",
              amount: "",
            };
          }, 8000);
        }
      } catch (error) {
        console.error("Error submitting lead:", error);
        // Fallback for user experience
        this.submitted = true; 
      }
    },
  },
  mounted() {
    // Language detection
    const savedLang = localStorage.getItem('landing_lang');
    if (savedLang) {
      this.setLanguage(savedLang);
    } else {
      const browserLang = navigator.language || navigator.userLanguage;
      if (browserLang && browserLang.toLowerCase().startsWith('es')) {
        this.setLanguage('sp'); // Using 'sp' for Spanish as per project convention
      } else {
        this.setLanguage('en');
      }
    }

    this.fetchAgentInfo();

    window.addEventListener('scroll', function (ev) {
        ev.preventDefault();
        var navbar = document.getElementById("navbar");
        if (navbar) {
            if (document.body.scrollTop >= 50 || document.documentElement.scrollTop >= 50) {
                navbar.classList.add("is-sticky");
            } else {
                navbar.classList.remove("is-sticky");
            }
        }
    });
  }
};
</script>

<template>
  <div class="layout-wrapper landing">
    
    <!-- Navbar -->
    <nav class="navbar navbar-expand-lg navbar-landing fixed-top bg-white shadow-sm" id="navbar">
      <div class="container">
        <a class="navbar-brand" href="/">
          <img src="@/assets/images/logo-dark.png" class="card-logo card-logo-dark" alt="logo" height="22">
        </a>
        <div class="ms-auto d-flex align-items-center">
          <!-- Translation Button -->
          <div class="dropdown me-3">
            <button class="btn btn-ghost-dark btn-sm dropdown-toggle rounded-pill px-3 fw-medium border" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              <i class="ri-global-line me-1"></i> {{ currentLanguage === 'en' ? 'English' : 'Español' }}
            </button>
            <ul class="dropdown-menu dropdown-menu-end shadow border-0 rounded-3">
              <li><a class="dropdown-item py-2" href="javascript:void(0);" @click="setLanguage('en')">English</a></li>
              <li><a class="dropdown-item py-2" href="javascript:void(0);" @click="setLanguage('sp')">Español</a></li>
            </ul>
          </div>
          <a href="#quote-form" class="btn btn-success rounded-pill px-4 fw-bold d-none d-md-inline-block">{{ $t('t-landing-get-quote') }}</a>
        </div>
      </div>
    </nav>
    <!-- end navbar -->

    <!-- Hero Section -->
    <section class="section pb-0 hero-section position-relative" style="background: linear-gradient(135deg, #f0f7f4 0%, #ffffff 100%);">
      <div class="bg-overlay bg-overlay-pattern opacity-10"></div>
      <div class="container pb-sm-5 z-1 position-relative">
        <div class="row align-items-start mb-5 pt-lg-5">
          <div class="col-lg-6 mt-lg-5">
            <h1 class="display-4 fw-bold mb-4 text-dark lh-sm">
              <span v-if="currentLanguage === 'en'">Peace of Mind with <span class="text-success">Final Expense</span> Insurance</span>
              <span v-else>{{ $t('t-landing-title') }}</span>
            </h1>
            <p class="lead text-muted mb-4 pe-md-5">
              {{ $t('t-landing-subtitle') }}
            </p>
            <div class="d-flex gap-3">
              <a href="#quote-form" class="btn btn-success btn-lg rounded-pill shadow-sm px-4 fw-bold">{{ $t('t-landing-apply-now') }} <i class="ri-arrow-right-line ms-2"></i></a>
              <a href="#about" class="btn btn-warning btn-lg rounded-pill px-4 fw-bold text-dark">{{ $t('t-landing-how-it-works') }}</a>
            </div>
            
            <div class="mt-5 d-flex align-items-center gap-3">
              <div class="avatar-group me-3">
                <div class="avatar-sm">
                  <img src="@/assets/images/users/avatar-1.jpg" alt="user" class="rounded-circle img-fluid border border-2 border-white">
                </div>
                <!-- Other avatars usually go here -->
              </div>
              <div>
                <h6 class="mb-0 fw-bold">{{ $t('t-landing-families-protected') }}</h6>
                <p class="text-muted mb-0 fs-12">{{ $t('t-landing-verified') }}</p>
              </div>
            </div>
          </div>
          
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0" id="quote-form">
            <div class="card shadow-lg border-0 rounded-4 overflow-hidden border-top border-5 border-success">
              <div class="card-header bg-white border-bottom-0 pt-4 pb-0 px-4">
                <h4 class="card-title fw-bold text-center mb-0 text-black">{{ $t('t-landing-form-title') }}</h4>
                <p class="text-muted text-center mt-2 fs-14">{{ $t('t-landing-form-subtitle') }}</p>
              </div>

              <!-- Agent Info Personalization -->
              <div v-if="agentInfo.firstName" class="bg-success-subtle py-3 px-4 border-bottom border-top border-white-50">
                <div class="d-flex align-items-center gap-3 justify-content-center">
                  <div v-if="agentInfo.profileIMG" class="avatar-sm">
                    <img :src="agentInfo.profileIMG" class="avatar-title rounded-circle shadow-sm" alt="agent">
                  </div>
                  <div v-else class="avatar-sm">
                      <div class="avatar-title bg-success rounded-circle text-white fw-bold shadow-sm">
                          {{ agentInfo.firstName[0] }}{{ agentInfo.lastName[0] }}
                      </div>
                  </div>
                  <div class="text-start">
                      <p class="mb-0 text-success fw-bold fs-11 text-uppercase tracking-wider">
                          {{ currentLanguage === 'en' ? 'Your Dedicated Agent' : 'Tu Agente Dedicado' }}
                      </p>
                      <h6 class="mb-0 fw-bold text-dark">{{ agentInfo.firstName }} {{ agentInfo.lastName }}</h6>
                  </div>
                </div>
              </div>
              <div class="card-body p-4">
                <form @submit.prevent="submitForm" v-if="!submitted">
                  <div class="mb-3">
                    <label class="form-label text-muted fw-semibold">{{ $t('t-landing-form-name') }}</label>
                    <input type="text" class="form-control form-control-lg bg-light border-light" v-model="formData.name" placeholder="John Doe" required>
                  </div>
                  <div class="mb-3">
                    <label class="form-label text-muted fw-semibold">{{ $t('t-landing-form-email') }}</label>
                    <input type="email" class="form-control form-control-lg bg-light border-light" v-model="formData.email" placeholder="john@example.com" required>
                  </div>
                  <div class="row">
                    <div class="col-md-6 mb-3">
                      <label class="form-label text-muted fw-semibold">{{ $t('t-landing-form-phone') }}</label>
                      <input type="tel" class="form-control form-control-lg bg-light border-light" v-model="formData.phone" placeholder="(555) 123-4567" required>
                    </div>
                    <div class="col-md-6 mb-3">
                      <label class="form-label text-muted fw-semibold">{{ $t('t-landing-form-amount') }}</label>
                      <select class="form-select form-select-lg bg-light border-light" v-model="formData.amount" required>
                        <option value="" disabled selected>{{ $t('t-landing-form-select') }}</option>
                        <option value="5000">$5,000</option>
                        <option value="10000">$10,000</option>
                        <option value="15000">$15,000</option>
                        <option value="20000">$20,000</option>
                        <option value="25000">$25,000+</option>
                      </select>
                    </div>
                  </div>
                  <div class="mt-4">
                    <button type="submit" class="btn btn-success btn-lg w-100 rounded-pill shadow-sm fw-bold">{{ $t('t-landing-form-submit') }}</button>
                  </div>
                  <div class="text-center mt-3">
                    <span class="badge bg-warning text-dark px-3 py-2 rounded-pill fs-11">{{ $t('t-landing-form-fast') }}</span>
                  </div>
                </form>
                
                <div v-else class="text-center py-5">
                  <div class="avatar-lg mx-auto mb-4">
                    <div class="avatar-title bg-success-subtle text-success rounded-circle display-4">
                      <i class="ri-checkbox-circle-fill"></i>
                    </div>
                  </div>
                  <h4 class="fw-bold">{{ $t('t-landing-form-requested') }}</h4>
                  <p class="text-muted">{{ $t('t-landing-form-thanks', { name: formData.name }) }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <!-- Information Section -->
    <section class="section bg-white py-5" id="about">
      <div class="container mt-4">
        <div class="row justify-content-center">
          <div class="col-lg-8 text-center mb-5">
            <h6 class="text-success text-uppercase fw-bold tracking-wide">{{ $t('t-landing-why') }}</h6>
            <h2 class="fw-bold mb-3 text-black">{{ $t('t-landing-what-is') }}</h2>
            <p class="text-muted fs-16">
              {{ $t('t-landing-what-desc') }}
            </p>
          </div>
        </div>
        
        <div class="row g-4 justify-content-center">
          <!-- Card 1 -->
          <div class="col-lg-4 col-md-6">
            <div class="card h-100 border-0 shadow-sm rounded-4 hover-lift transition-all">
              <div class="card-body p-4 p-xxl-5 text-center">
                <div class="avatar-md mx-auto mb-4">
                  <div class="avatar-title bg-success-subtle text-success rounded-circle fs-2">
                    <i class="ri-shield-user-line"></i>
                  </div>
                </div>
                <h4 class="fw-bold mb-3">{{ $t('t-landing-card1-title') }}</h4>
                <p class="text-muted mb-0">
                  {{ $t('t-landing-card1-desc') }}
                </p>
              </div>
            </div>
          </div>
          
          <!-- Card 2 -->
          <div class="col-lg-4 col-md-6">
            <div class="card h-100 border-0 shadow-sm rounded-4 hover-lift transition-all">
              <div class="card-body p-4 p-xxl-5 text-center">
                <div class="avatar-md mx-auto mb-4">
                  <div class="avatar-title bg-warning-subtle text-warning rounded-circle fs-2">
                    <i class="ri-money-dollar-circle-line"></i>
                  </div>
                </div>
                <h4 class="fw-bold mb-3 text-black">{{ $t('t-landing-card2-title') }}</h4>
                <p class="text-muted mb-0">
                  {{ $t('t-landing-card2-desc') }}
                </p>
              </div>
            </div>
          </div>
          
          <!-- Card 3 -->
          <div class="col-lg-4 col-md-6">
            <div class="card h-100 border-0 shadow-sm rounded-4 hover-lift transition-all">
              <div class="card-body p-4 p-xxl-5 text-center">
                <div class="avatar-md mx-auto mb-4">
                  <div class="avatar-title bg-dark text-white rounded-circle fs-2">
                    <i class="ri-heart-pulse-line"></i>
                  </div>
                </div>
                <h4 class="fw-bold mb-3">{{ $t('t-landing-card3-title') }}</h4>
                <p class="text-muted mb-0">
                  {{ $t('t-landing-card3-desc') }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Call to Action -->
    <section class="section py-5 bg-success position-relative overflow-hidden">
      <div class="bg-overlay bg-overlay-pattern opacity-10"></div>
      <div class="container position-relative z-1 text-center py-4">
        <h2 class="text-white fw-bold mb-4">{{ $t('t-landing-cta-title') }}</h2>
        <p class="text-white-50 fs-18 mb-5 mx-auto col-lg-7">{{ $t('t-landing-cta-subtitle') }}</p>
        <a href="#quote-form" class="btn btn-warning btn-lg rounded-pill px-5 fw-bold text-dark shadow">{{ $t('t-landing-cta-button') }}</a>
      </div>
    </section>

    <!-- Footer -->
    <footer class="landing-footer bg-dark pb-3 pt-5 text-white-50">
      <div class="container">
        <div class="row text-center text-sm-start align-items-center">
          <div class="col-sm-6 mb-3 mb-sm-0">
             <img src="@/assets/images/logo-light.png" alt="logo" height="20" class="mb-3">
             <p class="mb-0 text-white-50">{{ $t('t-landing-footer-rights') }}</p>
          </div>
          <div class="col-sm-6 text-sm-end mt-3 mt-sm-0">
              <ul class="list-inline mb-0">
                  <li class="list-inline-item"><a href="#" class="text-white-50 text-decoration-none">{{ $t('t-landing-privacy') }}</a></li>
                  <li class="list-inline-item ms-3"><a href="#" class="text-white-50 text-decoration-none">{{ $t('t-landing-terms') }}</a></li>
                  <li class="list-inline-item ms-3"><a href="#" class="text-white-50 text-decoration-none">{{ $t('t-landing-contact') }}</a></li>
              </ul>
          </div>
        </div>
      </div>
    </footer>
    
  </div>
</template>

<style scoped>
.landing-footer {
    padding: 50px 0;
    position: relative;
    z-index: 2;
}
.hover-lift {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}
.hover-lift:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
}
.navbar-landing {
  transition: all 0.3s ease;
  background: transparent !important;
  box-shadow: none !important;
}
.navbar-landing.is-sticky {
  background: white !important;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05) !important;
}
</style>
